import { useCallback, useMemo, useState } from "react";
import { IMinerProps } from "./Miner.props";
import { useUsers } from "@utils/hooks/useUsers";
import { UserI } from "@services/getUsers";

export const useMinerControl = (
  props: Omit<IMinerProps, "children" | "bottomClassName">
) => {
  const users = useUsers();
  const currentMeta = JSON.parse(props.meta || "{}");
  const [showFlag, setShowFlag] = useState<boolean>(
    (currentMeta?.flagText || currentMeta.flagColor)?.length > 0 || false
  );
  const [flagOpened, setFlagOpened] = useState<boolean>(false);
  const [user, setUser] = useState<UserI | undefined>();

  const onChangeShowFlag = (b: boolean) => {
    setShowFlag(b);
  };

  const afterFlagOpened = (isOpen: boolean) => {
    props.setOptimize?.(!isOpen);
    setFlagOpened(isOpen);

    console.log("isOpen = ", isOpen);
  };

  const loadUser = useCallback(() => {
    if (user) return;
    const u = users.find((u) => +u.id === +props.user_id);
    setUser(u);
  }, [props.user_id]);

  return {
    user,
    showFlag,
    currentMeta,
    flagOpened,

    onChangeShowFlag,
    afterFlagOpened,
    loadUser,
  };
};
